/*******************************************
* Screen reader only helper.
*******************************************/
/*
      |\      _,,,---,,_
ZZZzz /,`.-'`'    -.  ;-;;,_
     |,4-  ) )-,_. ,\ (  `'-'
    '---''(_/--'  `-'\_)

	Important! Generated file from keys in ace-betting-slip.get-names.ts 
*/
@keyframes appear-notification-indicator {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1);
    opacity: 0;
  }
  75% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes change-notification-indicator {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0);
  }
  75% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
:host {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
}
:host * {
  box-sizing: border-box;
}

.ace-betting-slip {
  background: var(--ace-color-surface-solid--100);
  border: unset;
  border-radius: var(--ace-primitive-radius-small);
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  position: relative;
}
@media only screen and (min-width: 1025px) {
  .ace-betting-slip {
    border: var(--ace-primitive-border-decorative) var(--ace-color-borders--100);
  }
}
.ace-betting-slip--fully-scrollable .ace-betting-slip__section--slip-content {
  overflow-y: auto;
}
.ace-betting-slip--fully-scrollable .ace-betting-slip__content {
  flex: 1;
  height: unset;
  overflow-y: unset;
}
.ace-betting-slip--fully-scrollable .ace-betting-slip__section--summary {
  position: relative;
}
.ace-betting-slip__slip-button {
  animation: appear-notification-indicator 200ms ease-out;
}
.ace-betting-slip__notification-indicator {
  transform-origin: center;
  animation: appear-notification-indicator 500ms ease-out;
}
.ace-betting-slip__notification-indicator--change {
  animation: change-notification-indicator 200ms ease-out;
}
.ace-betting-slip__remove-all-button {
  display: flex;
  justify-content: flex-end;
}
.ace-betting-slip__processing-overlay {
  align-items: center;
  background: var(--ace-color-surface-glass--ambience-darken);
  content: "";
  display: flex;
  flex-direction: column;
  gap: var(--ace-primitive-spacing-normal);
  height: 100%;
  justify-content: center;
  left: 0;
  padding: var(--ace-primitive-spacing-x-loose);
  position: absolute;
  right: 0;
  text-align: center;
  top: 0;
  z-index: 13;
}
@media only screen and (min-width: 1025px) {
  .ace-betting-slip__processing-overlay {
    border-radius: var(--ace-semantic-foundation-radius-s) var(--ace-semantic-foundation-radius-s) 0 0;
  }
}
.ace-betting-slip__desktop-nav {
  border-bottom: var(--ace-primitive-border-decorative) var(--ace-color-borders--100);
  padding: var(--ace-primitive-spacing-x-tight);
}
.ace-betting-slip__content {
  background: var(--ace-color-surface-solid--200);
  display: flex;
  flex-direction: column;
  gap: var(--ace-primitive-spacing-xx-tight);
  height: 100%;
  overflow-y: auto;
  padding: var(--ace-primitive-spacing-x-tight);
}
.ace-betting-slip__content--empty {
  padding: var(--ace-primitive-spacing-normal) var(--ace-primitive-spacing-x-tight);
}
.ace-betting-slip__section {
  display: none;
}
.ace-betting-slip__section--visible {
  display: flex;
  flex-direction: column;
}
.ace-betting-slip__section--content {
  flex: 1;
  overflow: hidden;
}
.ace-betting-slip__section--slip-content {
  height: 100%;
  max-height: 100%;
  overflow: hidden;
}
.ace-betting-slip__section--my-bets {
  height: 100%;
  overflow-y: hidden;
}
@media only screen and (min-width: 1025px) {
  .ace-betting-slip__section--my-bets {
    overflow-y: auto;
  }
}
.ace-betting-slip__section--my-bets ::slotted(ace-text) {
  min-height: fit-content;
}
.ace-betting-slip__section--summary {
  bottom: 0;
  position: sticky;
  z-index: 2;
}
.ace-betting-slip__sub-nav {
  display: flex;
  width: 100%;
}
.ace-betting-slip__slip-header {
  padding: var(--ace-primitive-spacing-x-tight);
}
.ace-betting-slip__profile-button {
  align-items: center;
  border-bottom: var(--ace-primitive-border-decorative) var(--ace-color-borders--100);
  display: flex;
  justify-content: center;
  padding: 0 var(--ace-primitive-spacing-x-tight);
}
@media only screen and (min-width: 1025px) {
  .ace-betting-slip__profile-button {
    border-left: var(--ace-primitive-border-decorative) var(--ace-color-borders--100);
  }
}
.ace-betting-slip__cashout-filter {
  align-items: center;
  border-bottom: var(--ace-primitive-border-decorative) var(--ace-color-borders--100);
  display: flex;
  gap: var(--ace-primitive-spacing-x-tight);
  height: 2.75rem;
  justify-content: space-between;
  padding: 0 var(--ace-primitive-spacing-x-tight);
}
.ace-betting-slip__success-header {
  align-items: center;
  display: flex;
  gap: var(--ace-primitive-spacing-xx-tight);
  justify-content: space-between;
}
.ace-betting-slip__mobile-nav {
  display: flex;
  gap: var(--ace-primitive-spacing-xx-tight);
}
.ace-betting-slip__mobile-nav--open {
  border-top: var(--ace-primitive-border-decorative) var(--ace-color-borders--100);
  padding: 1rem;
}
.ace-betting-slip__island {
  backdrop-filter: blur(2rem);
  -webkit-backdrop-filter: blur(2rem);
  background: var(--ace-color-gradient-stops-gradient-light-15);
  border: var(--ace-primitive-border-decorative) var(--ace-color-semantic-shaders-betting-island-start);
  border-radius: var(--ace-primitive-radius-large);
  bottom: var(--ace-primitive-spacing-x-tight);
  display: flex;
  flex-direction: column;
  gap: var(--ace-primitive-spacing-x-tight);
  left: 50%;
  padding: var(--ace-primitive-spacing-x-tight);
  position: fixed;
  transform: translateX(-50%);
  width: calc(100% - 2 * var(--ace-primitive-spacing-x-tight));
  z-index: 3;
}
@media only screen and (min-width: 595px) {
  .ace-betting-slip__island {
    max-width: 22rem;
  }
}
.ace-betting-slip__island--single-button {
  width: fit-content;
}
.ace-betting-slip__island--single-button .ace-betting-slip__island__buttons {
  justify-content: center;
}
.ace-betting-slip__island--single-button .ace-betting-slip__island__buttons ace-toggle-button {
  min-width: 10.56rem;
}
.ace-betting-slip__island--single-button ::slotted(ace-toast) {
  min-width: 20.5rem;
}
.ace-betting-slip__island__buttons {
  align-items: center;
  display: flex;
  gap: var(--ace-primitive-spacing-xx-tight);
  width: 100%;
}
.ace-betting-slip__island--anchored {
  bottom: var(--ace-betting-slip-bottom-offset, calc(2.8745rem + var(--ace-primitive-spacing-tight) + var(--ace-primitive-spacing-x-tight)));
}
.ace-betting-slip__island ::slotted(ace-toast) {
  border-radius: var(--ace-primitive-radius-small);
  max-width: 100%;
  width: 100%;
}
.ace-betting-slip__quote-acceptance-modal {
  background: var(--ace-color-surface-solid--100);
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 2;
}
.ace-betting-slip__footer {
  padding: var(--ace-primitive-spacing-tight);
}